'use strict';

var util = require('../../../util/property-util');
var graphUtil = require('../../../util/graph-util');
var Highcharts = require('highcharts/highstock');

module.exports = /*@ngInject*/ ["$scope", "$uibModalInstance", "$uibModal", "property", "$timeout", function($scope, $uibModalInstance, $uibModal, property, $timeout) {
    init();

    function init() {
        $timeout(function () {
            $scope.chart = new Highcharts.StockChart({
                chart: {
                    renderTo: 'amPreview'
                },
                exporting: {
                    enabled: false
                },
                plotOptions: {
                    line: {
                        cropThreshold: 100,
                        marker: {
                            states: {
                                hover: {
                                    radius: 4,
                                    lineWidth: 1

                                }
                            }
                        },
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        }
                    }
                },
                scrollbar: {
                    enabled: false,
                    liveRedraw: false
                },
                navigator: {
                    enabled: false

                },
                rangeSelector: {
                    enabled: false
                },
                xAxis: [{
                    crosshair: true,
                    ordinal: false
                }],
                yAxis: [
                    {
                        color: 'black'
                    }
                ],
                legend: {
                    enabled: false
                },
                series: [
                    {
                        name: 'PreviewSeries',
                        pointInterval: 1000,

                        data: [1, 4, 3, 1, 6],
                        yAxis: 0,
                        lineWidth: 1,
                        marker: {
                            radius: 3,
                            enabled: false
                        }

                    }
                ]
            });

            $timeout(function () {
                $scope.property = property;
                //if (!$scope.property.hasOwnProperty('color')) {
                //    $scope.property.color = "#ff0000";
                //}
                if (!$scope.property.hasOwnProperty('bullet')) {
                    $scope.property.bullet = "circle";
                }
                if (!$scope.property.hasOwnProperty('dashStyle')) {
                    $scope.property.dashStyle = "Solid";
                }
            });
        });
    }

    $scope.setDashLength = function () {
        updateGraph();
    };

    $scope.setBullet = function () {
        updateGraph();
    };

    function updateGraph() {
        var series = graphUtil.findSeries($scope.chart.series, 'PreviewSeries');
        $timeout(function () {
            //if (util.isDefined($scope.property.color)) {
            //    series.update({color: $scope.property.color});
            //}

            if (util.isDefined($scope.property.bullet)) {
                series.update({marker: {enabled: true, symbol: $scope.property.bullet}});
            }

            if (util.isDefined($scope.property.dashStyle)) {
                series.update({dashStyle: $scope.property.dashStyle});
            }
        });
    }

    $scope.close = function () {
        $uibModalInstance.dismiss();
    };

    $scope.save = function () {
        $scope.property.checked = true;
        $uibModalInstance.close();
    };

    //$scope.$watch('property.color;', function (newValue) {
    //    if (util.isDefined(newValue)) {
    //        updateGraph();
    //    }
    //}, true);

}];
